
class SignInService {
    async signIn(values, returnUrl) {
        var model = values;
        model.returnUrl = returnUrl;

        let response = await fetch('/SignIn/SignIn', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(model)
        });

        return response.json();
    }

    async getSingleSignOns() {
        let response = await fetch('/SignIn/SingleSignOns');

        return response.json();
    }

    async resendActivationEmail(userId, returnUrl) {
        let response = await fetch('/SignIn/ResendActivationEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                userId: userId,
                returnUrl: returnUrl
            })
        });

        return response;
    }

    async getLogInConfig(returnUrl) {
        let response = await fetch('/SignIn/LoginConfig', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                returnUrl: returnUrl
            })
        });

        return response.json();
    }

    async getEmailProvider(email) {
        let response = await fetch('/SignIn/EmailProvider',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify({email})
            });

        return response.text();
    }
};

const signInService = new SignInService();

export default signInService;